import { createAction } from 'redux-actions'
import {
  GET_JOB_CODES,
  GET_JOB_CODES_FAILED,
  GET_JOB_CODES_SUCCEEDED,
  CREATE_JOB_CODE,
  CREATE_JOB_CODE_FAILED,
  CREATE_JOB_CODE_SUCCEEDED,
} from 'Redux/Types/JobCodeTypes'

export const getJobCodes = createAction(GET_JOB_CODES)
export const getJobCodesFailed = createAction(GET_JOB_CODES_FAILED)
export const getJobCodesSucceeded = createAction(GET_JOB_CODES_SUCCEEDED)

export const createJobCode = createAction(CREATE_JOB_CODE)
export const createJobCodeFailed = createAction(CREATE_JOB_CODE_FAILED)
export const createJobCodeSucceeded = createAction(CREATE_JOB_CODE_SUCCEEDED)
